import { css, Divider, styled } from '@zeiss/beyond-online-react';

import { Grid } from 'src/components/Grid';
import { Box } from 'src/snowflakes/Box';

const StyledSectionGrid = styled(Grid)`
  /* Adjusts Grid gap on mobile screens to match designs */
  && {
    gap: var(--spacing-xs);

    @media (width >= 768px) {
      gap: var(--spacing-m);
    }
  }
`;

interface DividerProps {
  $bottom?: boolean;
}

const StyledDivider = styled(Divider)<DividerProps>`
  margin-bottom: var(--spacing-responsive-s);

  ${({ $bottom }) =>
    $bottom &&
    css`
      display: none;

      &:last-child {
        display: block;
      }
    `};
`;

interface SectionProps {
  children: React.ReactNode;
  hideDivider?: boolean;
}

export const Section = ({ children, hideDivider, ...rest }: SectionProps) => {
  return (
    <>
      {!hideDivider && <StyledDivider size="m" />}

      <Box as="section" spacing="s" {...rest}>
        <StyledSectionGrid>{children}</StyledSectionGrid>
      </Box>

      {!hideDivider && <StyledDivider $bottom size="m" />}
    </>
  );
};
